import { h, clear } from '../utils/dom.js';

export function renderSavedPanel(container, state, actions) {
	clear(container);

	if (state.features.bookmarks) {
		container.appendChild(h('div', { class: 'blb-section-heading' }, `⭐ ${state.i18n.bookmarks}`));

		if (state.bookmarks.length === 0) {
			container.appendChild(h('p', { class: 'blb-search-hint' }, 'No bookmarks yet. Tap a verse, then the star.'));
		}

		state.bookmarks.forEach((b) => {
			container.appendChild(
				h('div', { class: 'blb-list-item' }, [
					h(
						'div',
						{
							class: 'blb-list-item-main',
							onClick: () => actions.goToReference({ book: b.book, chapter: b.chapter, verse: b.verse }),
							style: 'cursor:pointer;',
						},
						[
							h('div', { class: 'blb-list-item-ref' }, `${b.book} ${b.chapter}:${b.verse}`),
							h('div', { class: 'blb-list-item-text' }, b.text),
						]
					),
					h(
						'button',
						{ class: 'blb-icon-btn', title: 'Remove', onClick: () => actions.removeBookmark(b.book, b.chapter, b.verse) },
						'✕'
					),
				])
			);
		});
	}

	if (state.features.highlights) {
		container.appendChild(h('div', { class: 'blb-section-heading' }, `🖍️ ${state.i18n.highlights}`));

		const entries = Object.entries(state.highlights || {});
		if (entries.length === 0) {
			container.appendChild(h('p', { class: 'blb-search-hint' }, 'No highlighted verses yet.'));
		}

		entries.forEach(([key, color]) => {
			// Highlight keys are "book-chapter-verse" (storage.js), but many
			// book ids themselves contain hyphens (e.g. "2-timothy",
			// "song-of-solomon"), so a plain 3-way split mis-parses them.
			// Chapter and verse are always the last two segments (plain
			// digits), so pop those from the end and treat everything
			// remaining, rejoined, as the book id.
			const parts = key.split('-');
			const verse = parts.pop();
			const chapter = parts.pop();
			const book = parts.join('-');
			container.appendChild(
				h('div', { class: 'blb-list-item' }, [
					h('span', { class: 'blb-highlight-swatch blb-hl-' + color, style: 'flex:0 0 auto;' }),
					h(
						'div',
						{
							class: 'blb-list-item-main',
							onClick: () => actions.goToReference({ book, chapter: parseInt(chapter, 10), verse: parseInt(verse, 10) }),
							style: 'cursor:pointer;',
						},
						h('div', { class: 'blb-list-item-ref' }, `${book} ${chapter}:${verse}`)
					),
					h(
						'button',
						{
							class: 'blb-icon-btn',
							title: 'Remove highlight',
							onClick: () => actions.setHighlight(parseInt(verse, 10), null, book, parseInt(chapter, 10)),
						},
						'✕'
					),
				])
			);
		});
	}

	if (state.features.notes) {
		container.appendChild(h('div', { class: 'blb-section-heading' }, '📝 Notes'));

		const notes = Object.values(state.notes || {}).sort((a, b) => b.ts - a.ts);
		if (notes.length === 0) {
			container.appendChild(h('p', { class: 'blb-search-hint' }, 'No notes yet. Tap a verse, then the pencil.'));
		}

		notes.forEach((n) => {
			container.appendChild(
				h('div', { class: 'blb-list-item' }, [
					h(
						'div',
						{
							class: 'blb-list-item-main',
							onClick: () => actions.goToReference({ book: n.book, chapter: n.chapter, verse: n.verse }),
							style: 'cursor:pointer;',
						},
						[
							h('div', { class: 'blb-list-item-ref' }, `${n.book} ${n.chapter}:${n.verse}`),
							h('div', { class: 'blb-list-item-text' }, n.text),
						]
					),
					h(
						'button',
						{ class: 'blb-icon-btn', title: 'Delete note', onClick: () => actions.deleteNote(n.verse, n.book, n.chapter) },
						'✕'
					),
				])
			);
		});
	}
}
